 import React, { Fragment, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import { useEffect } from 'react';
import logout_img from "../../../../images/logout.png";

const Compose = () => {
  const history = useHistory();

const [count_not, setUser] = useState(0);

useEffect(() => {
    const auth_token = localStorage.getItem('auth_token');
    const selectedCurrency = localStorage.getItem('selectedCurrency');

    const data = {
        key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
        currency: selectedCurrency,
    };

    if (auth_token) {
        axios.post('/notifications-count', data)
        .then(response => {
            setUser(response.data.notifaction || 0);
            console.log(response.data);
        })
        .catch(error => {
            console.log(error);
        });
    }
}, []);


  const logoutSubmit = (e) => {
    e.preventDefault();
    axios.post(`/logout`).then((res) => {
      if (res.data.message === "Unauthenticated") {
        localStorage.removeItem("auth_token");
        swal("Success", res.data.message, "success");
        history.push("/login");
      }
    });
  };

  return (
    <Fragment>
      <div className="row">
        <div className="col-lg-12">
          <div className="card shadow-sm border-0">
            <div className="card-body p-4">
              <div className="email-left-box">
                
                {/* Wallet Section */}
                <div className="menu-section">
  <h6 className="section-title mb-4" style={{ fontWeight: "700", fontSize: "18px" }}>Wallet</h6>
  
  <div className="row">


    <div className="col-4 mb-4 text-center">
      <Link to="/app-notifications" className="d-block text-decoration-none">
        <div 
          style={{ 
            backgroundColor: "#f8f9fa", 
            borderRadius: "12px", 
            padding: "15px", 
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            position: "relative"
          }}
        >
          <i className="fas fa-bell" style={{ fontSize: "24px", color: "#ffc107" }}></i>

          {/* Notification Count */}
          <span
            style={{
              position: "absolute",
              top: "5px",
              right: "10px",
              background: "red",
              color: "white",
              borderRadius: "50%",
              minWidth: "20px",
              height: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "10px"
            }}
          >
            {count_not}
          </span>
          <div style={{ marginTop: "8px", fontSize: "10px", color: "#343a40", fontWeight: "500" }}>
            Notifications
          </div>
        </div>
      </Link>
    </div>


    <div className="col-4 mb-4 text-center">
      <Link to="/app-asset" className="d-block text-decoration-none">
        <div 
          style={{ 
            backgroundColor: "#f8f9fa", 
            borderRadius: "12px", 
            padding: "15px", 
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
          }}
        >
          <i className="fas fa-money-bill-alt" style={{ fontSize: "24px", color: "#007bff" }}></i>
          <div style={{ marginTop: "8px", fontSize: "10px", color: "#343a40", fontWeight: "500" }}>Wallet</div>
        </div>
      </Link>
    </div>

    <div className="col-4 mb-4 text-center">
      <Link to="/convert-balance" className="d-block text-decoration-none">
        <div 
          style={{ 
            backgroundColor: "#f8f9fa", 
            borderRadius: "12px", 
            padding: "15px", 
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
          }}
        >
          <i className="fas fa-exchange-alt" style={{ fontSize: "24px", color: "#28a745" }}></i>
          <div style={{ marginTop: "8px", fontSize: "10px", color: "#343a40", fontWeight: "500" }}>Convert</div>
        </div>
      </Link>
    </div>

    <div className="col-4 mb-4 text-center">
      <Link to="/withdraw" className="d-block text-decoration-none">
        <div 
          style={{ 
            backgroundColor: "#f8f9fa", 
            borderRadius: "12px", 
            padding: "15px", 
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
          }}
        >
          <i className="fas fa-hand-holding-usd" style={{ fontSize: "24px", color: "#17a2b8" }}></i>
          <div style={{ marginTop: "8px", fontSize: "10px", color: "#343a40", fontWeight: "500" }}>Withdrawal</div>
        </div>
      </Link>
    </div>

    <div className="col-4 mb-4 text-center">
      <Link to="/deposit" className="d-block text-decoration-none">
        <div 
          style={{ 
            backgroundColor: "#f8f9fa", 
            borderRadius: "12px", 
            padding: "15px", 
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
          }}
        >
          <i className="fas fa-credit-card" style={{ fontSize: "24px", color: "#6f42c1" }}></i>
          <div style={{ marginTop: "8px", fontSize: "10px", color: "#343a40", fontWeight: "500" }}>Recharge</div>
        </div>
      </Link>
    </div>

    <div className="col-4 mb-4 text-center">
      <Link to="/withdraw-method" className="d-block text-decoration-none">
        <div 
          style={{ 
            backgroundColor: "#f8f9fa", 
            borderRadius: "12px", 
            padding: "15px", 
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
          }}
        >
          <i className="fas fa-university" style={{ fontSize: "24px", color: "#dc3545" }}></i>
          <div style={{ marginTop: "8px", fontSize: "10px", color: "#343a40", fontWeight: "500" }}>Withdrawal Method</div>
        </div>
      </Link>
    </div>
  </div>
</div>


                {/* Report Section */}
                <div className="menu-section">
  <h6 className="section-title mb-4" style={{ fontWeight: "700", fontSize: "18px" }}>Report</h6>

  <div className="row">
    <div className="col-4 mb-4 text-center">
      <Link 
        to="/withdrawal-history" 
        className="d-block text-decoration-none"
        style={{ transition: "0.3s" }}
      >
        <div 
          style={{
            backgroundColor: "#f8f9fa",
            borderRadius: "12px",
            padding: "15px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            transition: "all 0.3s",
          }}
          className="hover-effect"
        >
          <i className="fas fa-receipt" style={{ fontSize: "24px", color: "#0d6efd" }}></i>
          <div style={{ marginTop: "8px", fontSize: "10px", color: "#343a40", fontWeight: "500" }}>Withdrawal History</div>
        </div>
      </Link>
    </div>

    <div className="col-4 mb-4 text-center">
      <Link to="/community-log" className="d-block text-decoration-none" style={{ transition: "0.3s" }}>
        <div 
          style={{
            backgroundColor: "#f8f9fa",
            borderRadius: "12px",
            padding: "15px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            transition: "all 0.3s",
          }}
          className="hover-effect"
        >
          <i className="fas fa-user-lock" style={{ fontSize: "24px", color: "#198754" }}></i>
          <div style={{ marginTop: "8px", fontSize: "10px", color: "#343a40", fontWeight: "500" }}>Invest Log</div>
        </div>
      </Link>
    </div>

    <div className="col-4 mb-4 text-center">
      <Link to="/transaction-history" className="d-block text-decoration-none" style={{ transition: "0.3s" }}>
        <div 
          style={{
            backgroundColor: "#f8f9fa",
            borderRadius: "12px",
            padding: "15px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            transition: "all 0.3s",
          }}
          className="hover-effect"
        >
          <i className="fa fa-list-ul" style={{ fontSize: "24px", color: "#fd7e14" }}></i>
          <div style={{ marginTop: "8px", fontSize: "10px", color: "#343a40", fontWeight: "500" }}>Transaction History</div>
        </div>
      </Link>
    </div>

    <div className="col-4 mb-4 text-center">
      <Link to="/income-history" className="d-block text-decoration-none" style={{ transition: "0.3s" }}>
        <div 
          style={{
            backgroundColor: "#f8f9fa",
            borderRadius: "12px",
            padding: "15px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            transition: "all 0.3s",
          }}
          className="hover-effect"
        >
          <i className="fas fa-chart-line" style={{ fontSize: "24px", color: "#6610f2" }}></i>
          <div style={{ marginTop: "8px", fontSize: "10px", color: "#343a40", fontWeight: "500" }}>Income History</div>
        </div>
      </Link>
    </div>
  </div>
</div>


 {/* Team Section */}
<div className="menu-section">
  <h6 style={{ fontWeight: "700", fontSize: "18px", marginBottom: "20px" }}>Team</h6>

  <div className="row">
    <div className="col-4 mb-4 text-center">
      <Link
        to="/affiliate"
        className="d-block text-decoration-none"
        style={{
          textAlign: "center",
          textDecoration: "none",
          color: "#343a40",
          transition: "all 0.3s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.children[0].style.backgroundColor = "#e9ecef";
          e.currentTarget.children[0].style.transform = "translateY(-3px)";
          e.currentTarget.children[0].style.boxShadow = "0 6px 12px rgba(0,0,0,0.15)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.children[0].style.backgroundColor = "#f8f9fa";
          e.currentTarget.children[0].style.transform = "translateY(0)";
          e.currentTarget.children[0].style.boxShadow = "0 2px 6px rgba(0,0,0,0.1)";
        }}
      >
        <div
          style={{
            backgroundColor: "#f8f9fa",
            borderRadius: "12px",
            padding: "15px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            transition: "all 0.3s",
          }}
        >
          <i className="fas fa-bullhorn" style={{ fontSize: "24px", color: "#0dcaf0" }}></i>
          <div style={{ marginTop: "8px", fontSize: "10px", fontWeight: "500" }}>
            Promotion
          </div>
        </div>
      </Link>
    </div>


    <div className="col-4 mb-4 text-center">
      <Link
        to="/my-smart-team"
        className="d-block text-decoration-none"
        style={{
          textAlign: "center",
          textDecoration: "none",
          color: "#343a40",
          transition: "all 0.3s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.children[0].style.backgroundColor = "#e9ecef";
          e.currentTarget.children[0].style.transform = "translateY(-3px)";
          e.currentTarget.children[0].style.boxShadow = "0 6px 12px rgba(0,0,0,0.15)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.children[0].style.backgroundColor = "#f8f9fa";
          e.currentTarget.children[0].style.transform = "translateY(0)";
          e.currentTarget.children[0].style.boxShadow = "0 2px 6px rgba(0,0,0,0.1)";
        }}
      >
        <div
          style={{
            backgroundColor: "#f8f9fa",
            borderRadius: "12px",
            padding: "15px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            transition: "all 0.3s",
          }}
        >
          <i className="fas fa-user-friends" style={{ fontSize: "24px", color: "#198754" }}></i>
          <div style={{ marginTop: "8px", fontSize: "10px", fontWeight: "500" }}>
            My Team
          </div>
        </div>
      </Link>
    </div>

    <div className="col-4 mb-4 text-center">
      <Link
        to="/team-statement"
        className="d-block text-decoration-none"
        style={{
          textAlign: "center",
          textDecoration: "none",
          color: "#343a40",
          transition: "all 0.3s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.children[0].style.backgroundColor = "#e9ecef";
          e.currentTarget.children[0].style.transform = "translateY(-3px)";
          e.currentTarget.children[0].style.boxShadow = "0 6px 12px rgba(0,0,0,0.15)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.children[0].style.backgroundColor = "#f8f9fa";
          e.currentTarget.children[0].style.transform = "translateY(0)";
          e.currentTarget.children[0].style.boxShadow = "0 2px 6px rgba(0,0,0,0.1)";
        }}
      >
        <div
          style={{
            backgroundColor: "#f8f9fa",
            borderRadius: "12px",
            padding: "15px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            transition: "all 0.3s",
          }}
        >
          <i className="fa fa-list" style={{ fontSize: "24px", color: "#198754" }}></i>
          <div style={{ marginTop: "8px", fontSize: "10px", fontWeight: "500" }}>
            Team Statement
          </div>
        </div>
      </Link>
    </div>

  </div>
</div>


{/* Account Security Section */}
<div className="menu-section">
  <h6 style={{ fontWeight: "700", fontSize: "18px", marginBottom: "20px" }}>Account Security</h6>

  <div className="row">
    {[
      { to: "/change-password", icon: "fas fa-key", text: "Change Password", color: "#dc3545" },
      { to: "/change-transaction-password", icon: "fas fa-unlock-alt", text: "Transaction Password", color: "#ffc107" },
    ].map((item, index) => (
      <div className="col-4 mb-4 text-center" key={index}>
        <Link
          to={item.to}
          className="d-block text-decoration-none"
          style={{
            textAlign: "center",
            textDecoration: "none",
            color: "#343a40",
            transition: "all 0.3s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.children[0].style.backgroundColor = "#e9ecef";
            e.currentTarget.children[0].style.transform = "translateY(-3px)";
            e.currentTarget.children[0].style.boxShadow = "0 6px 12px rgba(0,0,0,0.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.children[0].style.backgroundColor = "#f8f9fa";
            e.currentTarget.children[0].style.transform = "translateY(0)";
            e.currentTarget.children[0].style.boxShadow = "0 2px 6px rgba(0,0,0,0.1)";
          }}
        >
          <div
            style={{
              backgroundColor: "#f8f9fa",
              borderRadius: "12px",
              padding: "15px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              transition: "all 0.3s",
            }}
          >
            <i className={item.icon} style={{ fontSize: "24px", color: item.color }}></i>
            <div style={{ marginTop: "8px", fontSize: "10px", fontWeight: "500" }}>
              {item.text}
            </div>
          </div>
        </Link>
      </div>
    ))}

    <div className="col-4 mb-4 text-center">
      <Link
        to="/security"
        className="d-block text-decoration-none"
        style={{
          textAlign: "center",
          textDecoration: "none",
          color: "#343a40",
          transition: "all 0.3s",
        }}
      >
        <div
          style={{
            backgroundColor: "#f8f9fa",
            borderRadius: "12px",
            padding: "15px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            transition: "all 0.3s",
          }}
        >
          <i className="fas fa-user-lock" style={{ fontSize: "24px", color: "#0d6efd" }}></i>
          <div style={{ marginTop: "8px", fontSize: "12px", fontWeight: "500" }}>
            Security
          </div>
        </div>
      </Link>
    </div>
    <div className="col-4 mb-4 text-center">
      <Link
        to="/identity-verification"
        className="d-block text-decoration-none"
        style={{
          textAlign: "center",
          textDecoration: "none",
          color: "#343a40",
          transition: "all 0.3s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.children[0].style.backgroundColor = "#e9ecef";
          e.currentTarget.children[0].style.transform = "translateY(-3px)";
          e.currentTarget.children[0].style.boxShadow = "0 6px 12px rgba(0,0,0,0.15)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.children[0].style.backgroundColor = "#f8f9fa";
          e.currentTarget.children[0].style.transform = "translateY(0)";
          e.currentTarget.children[0].style.boxShadow = "0 2px 6px rgba(0,0,0,0.1)";
        }}
      >
        <div
          style={{
            backgroundColor: "#f8f9fa",
            borderRadius: "12px",
            padding: "15px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            transition: "all 0.3s",
          }}
        >
          <i className="fas fa-shield-alt" style={{ fontSize: "24px", color: "#0d6efd" }}></i>
          <div style={{ marginTop: "8px", fontSize: "12px", fontWeight: "500" }}>
             Verification
          </div>
        </div>
      </Link>
    </div>    
  </div>
</div>




{/* Support Section */}
<div className="menu-section">
  <h6 style={{ fontWeight: "700", fontSize: "18px", marginBottom: "20px" }}>Support</h6>

  <div className="row">
    <div className="col-4 mb-4 text-center">
      <Link
        to="/support-ticket"
        className="d-block text-decoration-none"
        style={{
          textAlign: "center",
          textDecoration: "none",
          color: "#343a40",
          transition: "all 0.3s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.children[0].style.backgroundColor = "#e9ecef";
          e.currentTarget.children[0].style.transform = "translateY(-3px)";
          e.currentTarget.children[0].style.boxShadow = "0 6px 12px rgba(0,0,0,0.15)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.children[0].style.backgroundColor = "#f8f9fa";
          e.currentTarget.children[0].style.transform = "translateY(0)";
          e.currentTarget.children[0].style.boxShadow = "0 2px 6px rgba(0,0,0,0.1)";
        }}
      >
        <div
          style={{
            backgroundColor: "#f8f9fa",
            borderRadius: "12px",
            padding: "15px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            transition: "all 0.3s",
          }}
        >
          <i className="fas fa-headset" style={{ fontSize: "24px", color: "#6610f2" }}></i>
          <div style={{ marginTop: "8px", fontSize: "12px", fontWeight: "500" }}>
            Support Ticket
          </div>
        </div>
      </Link>
    </div>
  </div>
</div>

{/* Logout Button */}
<div className="menu-section mt-4">
  <div className="row">
    <div className="col-12 text-center">
      <button
        onClick={logoutSubmit}
        className="btn btn-danger"
        style={{
          background: '#002f6a',
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "10px 15px",
          fontWeight: "600",
          fontSize: "16px",
          borderRadius: "12px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
          transition: "all 0.3s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-3px)";
          e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,0,0.2)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.15)";
        }}
      >
        <img src={logout_img} alt="Logout" width="20" className="me-2" />
        Logout
      </button>
    </div>
  </div>
</div>

 {/* <div className="menu-section mt-4">
  <button
    onClick={logoutSubmit}
    className="btn btn-danger btn-md px-3 py-2 d-flex align-items-center justify-content-center"
    style={{ fontSize: "13px", borderRadius: "6px" }}
  >
    <img src={logout_img} alt="Logout" width="16" className="me-2" />
    Logout
  </button>
</div> */}


              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Inline Styles */}
      <style jsx="true">{`
        .menu-section {
          margin-bottom: 24px;
        }
        .section-title {
          font-size: 24px;
          font-weight: 600;
          color: #333;
          margin-bottom: 12px;
          text-transform: uppercase;
        }
        .menu-link {
          display: flex;
          align-items: center;
          padding: 10px 15px;
          border-radius: 8px;
          color: #555;
          text-decoration: none;
          font-size: 19px;
          margin-bottom: 6px;
          transition: all 0.3s;
        }
        .menu-link:hover {
          background-color: #f0f0f0;
          color: #000;
        }
        .menu-link.active {
          background-color: #002f6a;
          color: #fff;
        }
      `}</style>
    </Fragment>
  );
};

export default Compose;
